import { createAction } from 'redux-actions'; 

export default{
    updateState: createAction('UPDATE_STATE'),
 };